export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-12 md:py-16">
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-8">
          {/* Logo and name */}
          <div className="flex flex-col items-center md:items-start gap-4">
            <img
              src="https://public.readdy.ai/ai/img_res/87b2fe15-5090-4cb3-9988-9eae2093cc31.png"
              alt="다온심리상담센터 로고"
              className="h-14 md:h-16 w-auto object-contain"
            />
            <p className="text-sm text-foreground-600 text-center md:text-left">
              마음의 회복과 성장을 위한 동행
            </p>
          </div>

          {/* Nav links */}
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-2">
            <a href="#about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap" onClick={(e) => {
              e.preventDefault()
              document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' })
            }}>센터 소개</a>
            <a href="#values" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap" onClick={(e) => {
              e.preventDefault()
              document.querySelector('#values')?.scrollIntoView({ behavior: 'smooth' })
            }}>핵심 가치</a>
            <a href="#activities" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap" onClick={(e) => {
              e.preventDefault()
              document.querySelector('#activities')?.scrollIntoView({ behavior: 'smooth' })
            }}>주요 활동</a>
            <a href="#vision" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap" onClick={(e) => {
              e.preventDefault()
              document.querySelector('#vision')?.scrollIntoView({ behavior: 'smooth' })
            }}>비전</a>
            <a href="#notices" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap" onClick={(e) => {
              e.preventDefault()
              document.querySelector('#notices')?.scrollIntoView({ behavior: 'smooth' })
            }}>공지사항</a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 text-center">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 다온심리상담센터. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}